import { render, staticRenderFns } from "./InspectEdit.vue?vue&type=template&id=97bbce3c&scoped=true"
import script from "./InspectEdit.vue?vue&type=script&lang=js"
export * from "./InspectEdit.vue?vue&type=script&lang=js"
import style0 from "./InspectEdit.vue?vue&type=style&index=0&id=97bbce3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bbce3c",
  null
  
)

export default component.exports